<template>
  <panel title="Adatok">
    <Loading v-if="task === false" title="Munkafolyamat betöltése"></Loading>
    <div v-else>
      <div class="table-responsive">
        <table class="table table-hover">
          <tbody>
            <tr>
              <th>Munkafolyamat száma</th>
              <td>#{{ task.id }}</td>
            </tr>
            <tr>
              <th>Név</th>
              <td>{{ task.name }}</td>
            </tr>
            <tr>
              <th>Lakatolás</th>
              <td>
                <span v-if="security_types">{{
                  security_types.find((s) => s.id == task.security_type).name
                }}</span>
              </td>
            </tr>
            <tr>
              <th>Létrehozva</th>
              <td>{{ task.created_at | moment("YYYY-MM-DD HH:mm") }}</td>
            </tr>
            <tr>
              <th>Projektvezető</th>
              <td>
                {{ task.owner_simple.name }}
                <button
                  @click="takeFromOwner"
                  v-if="
                    ![70].includes(task.status) &&
                    user.role_id == 5 &&
                    user.id != task.owner_id
                  "
                  class="btn btn-xs btn-warning rounded-pill"
                  :disabled="loading"
                >
                  <i class="fa fa-cog fa-spin" v-if="loading"></i> Átveszem
                </button>
              </td>
            </tr>
            <tr>
              <th>Területvezető</th>
              <td>
                <v-select
                  v-if="
                    location_leads &&
                    user &&
                    task.owner_id == user.id &&
                    user.role_id == 5 &&
                    task.status == 10
                  "
                  @option:selected="setLocationLeader"
                  v-model="location_leader_id"
                  :options="location_leads"
                  label="name"
                  :reduce="(p) => p.id"
                  :clearable="false"
                  :disabled="loading"
                >
                  <template #search="{ attributes, events }">
                    <input
                      class="vs__search"
                      v-bind="attributes"
                      v-on="events"
                      :placeholder="task.location_leader_id ? '' : 'Válassz'"
                    />
                  </template>
                </v-select>
                <span v-else>
                  {{ task.location_leader_simple.name }}
                  <button
                    @click="takeFromLocationLeader"
                    v-if="
                      ![70].includes(task.status) &&
                      user.role_id == 3 &&
                      user.id != task.location_leader_id
                    "
                    class="btn btn-xs btn-warning rounded-pill"
                    :disabled="loading"
                  >
                    <i class="fa fa-cog fa-spin" v-if="loading"></i> Átveszem
                  </button>
                </span>
              </td>
            </tr>
            <tr>
              <th>Területi igény ideje</th>
              <td>
                <span
                  >{{
                    JSON.parse(task.additional)
                      .start_date.concat(" ")
                      .concat(JSON.parse(task.additional).start_time)
                      | moment("YYYY-MM-DD HH:mm")
                  }}
                  -
                  {{ task.validity.end_date_time | moment("YYYY-MM-DD HH:mm") }}
                </span>
                <button
                  v-b-modal="'approve_extension_task'"
                  v-if="task.has_unresolved_validity"
                  class="btn btn-yellow btn-xs mx-1"
                  :disabled="
                    !(
                      user.role_id == 3 &&
                      [task.location_leader_id].includes(user.id)
                    )
                  "
                >
                  Aktív meghosszabbítási kérvény
                </button>
                <button
                  v-else-if="
                    ((user.role_id == 5 && [task.owner_id].includes(user.id)) ||
                      (user.role_id == 3 &&
                        [task.location_leader_id].includes(user.id))) &&
                    diffLessThanThreeDays(task.validity.end_date_time) &&
                    task.status < 60
                  "
                  class="btn btn-indigo btn-xs mx-1"
                  v-b-modal="'fill_extension_task'"
                >
                  Meghosszabbítás
                </button>
                <b-modal
                  size="md"
                  id="fill_extension_task"
                  cancel-title="Mégse"
                  ok-title="Meghosszabbítás"
                  @ok="extendTask(task.id)"
                  @shown="getTaskValidityRecords()"
                >
                  <template slot="modal-header">
                    <h4 class="modal-title">munkafolyamat meghosszabbítása</h4>
                    <a
                      class="btn-close"
                      @click="$bvModal.hide('fill_extension_task')"
                    ></a>
                  </template>
                  <b-container>
                    <h5>
                      Érvényesség kezdete:
                      {{
                        JSON.parse(task.additional)
                          .start_date.concat(" ")
                          .concat(JSON.parse(task.additional).start_time)
                          | moment("YYYY-MM-DD HH:mm")
                      }}
                    </h5>
                    <Loading
                      v-if="!validity_records"
                      title="Érvényességi rekordok betöltése"
                    ></Loading>
                    <div v-else>
                      <h5>Érvényességi rekordok:</h5>
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Dátum és idő</th>
                            <th>Esemény</th>
                            <th>Állapot</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(v_rec, id) in validity_records" :key="id">
                            <td>{{ getSlicedDate(v_rec.end_date_time) }}</td>
                            <td>
                              {{
                                v_rec.end_date_time ==
                                task.validity.end_date_time
                                  ? "érvényesség vége"
                                  : "meghosszabbítás"
                              }}
                            </td>
                            <td>
                              <p v-if="v_rec.active">Elfogadva</p>
                              <p v-else-if="v_rec.deleted_at == null">
                                Jóváhagyásra vár
                              </p>
                              <p v-else>Elutasítva</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <label class="form-label"
                      >Ez a munkafolyamat a következő dátumig érvényes:</label
                    >
                    <div class="row">
                      <div class="col-md-8">
                        <div class="form-group mt-2">
                          <input
                            type="date"
                            class="form-control"
                            v-model="end_date"
                            :min="
                              task.validity.end_date_time | moment('yyyy-MM-DD')
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group mt-2">
                          <input
                            v-if="with_time"
                            type="time"
                            class="form-control"
                            v-model="end_time"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-check mt-2">
                      <input
                        class="form-check-input"
                        :true-value="false"
                        :false-value="true"
                        type="checkbox"
                        v-model="with_time"
                        id="with_time_input"
                      />
                      <label class="form-check-label" for="with_time_input"
                        >Egész nap</label
                      >
                    </div>
                  </b-container>
                </b-modal>
                <b-modal
                  size="md"
                  id="approve_extension_task"
                  hide-footer
                  @shown="getTaskValidityRecords()"
                >
                  <template slot="modal-header">
                    <h4 class="modal-title">munkafolyamat meghosszabbításai</h4>
                    <a
                      class="btn-close"
                      @click="$bvModal.hide('approve_extension_task')"
                    ></a>
                  </template>
                  <b-container>
                    <h5>
                      Érvényesség kezdete:
                      {{ getSlicedDate(task.validity.start_date_time) }}
                    </h5>
                    <Loading
                      v-if="!validity_records"
                      title="Érvényességi rekordok betöltése"
                    ></Loading>
                    <div v-else>
                      <h5>Érvényességi rekordok:</h5>
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Dátum és idő</th>
                            <th>Esemény</th>
                            <th>Státusz</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(v_rec, id) in validity_records" :key="id">
                            <td>{{ getSlicedDate(v_rec.end_date_time) }}</td>
                            <td>
                              {{
                                v_rec.end_date_time ==
                                task.validity.end_date_time
                                  ? "érvényesség vége"
                                  : "meghosszabbítva"
                              }}
                            </td>
                            <td>
                              <span
                                v-if="v_rec.active == 1"
                                class="badge bg-green"
                                ><i class="fa fa-check-circle"></i>
                                jóváhagyva</span
                              >
                              <span
                                v-else-if="v_rec.deleted_at != null"
                                class="badge bg-danger"
                                ><i class="fa fa-times"></i> elutasítva</span
                              >
                              <div v-else>
                                <button
                                  class="btn btn-xs btn-lime mx-1"
                                  @click="validityActiveUpdate(v_rec.id, 1)"
                                >
                                  Jóváhagyom
                                </button>
                                <button
                                  class="btn btn-xs btn-danger mx-1"
                                  @click="validityActiveUpdate(v_rec.id, 0)"
                                >
                                  Elutasítom
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-container>
                </b-modal>
              </td>
            </tr>
            <tr>
              <th>Kék lakat felvevő</th>
              <td
                v-if="
                  (task.status == 15 &&
                    [task.location_leader_id].includes(user.id)) ||
                  (task.status == 30 && user.id == task.operator_id) ||
                  (task.status == 10 &&
                    [task.owner_id].includes(user.id) &&
                    user.role_id == 5)
                "
              >
                <v-select
                  v-if="ddc_users"
                  @option:selected="setDdcUser"
                  v-model="ddc_user_id"
                  :options="ddc_users"
                  label="name"
                  :reduce="(p) => p.id"
                  :clearable="false"
                >
                  <template #search="{ attributes, events }">
                    <input
                      class="vs__search"
                      v-bind="attributes"
                      v-on="events"
                      :placeholder="!task.ddc_user_id ? 'Válassz' : ''"
                    />
                  </template>
                </v-select>
              </td>
              <td v-else>
                {{ task.ddc_user_simple ? task.ddc_user_simple.name : "nincs" }}
              </td>
            </tr>
            <tr v-if="task.black_lock_user_id">
              <th>Fekete lakat felvevő</th>
              <td
                v-if="
                  (task.status == 15 &&
                    [task.location_leader_id].includes(user.id)) ||
                  (task.status == 30 && user.id == task.operator_id) ||
                  (task.status == 10 &&
                    [task.owner_id].includes(user.id) &&
                    user.role_id == 5)
                "
              >
                <v-select
                  v-if="partner_users"
                  @option:selected="setBlackLockUser"
                  v-model="black_lock_user_id"
                  :options="partner_users"
                  label="name"
                  :reduce="(p) => p.id"
                  :clearable="false"
                >
                  <template #search="{ attributes, events }">
                    <input
                      class="vs__search"
                      v-bind="attributes"
                      v-on="events"
                      :placeholder="!task.ddc_user_id ? 'Válassz' : ''"
                    />
                  </template>
                </v-select>
              </td>
              <td v-else>
                {{ black_lock_user ? black_lock_user.name : "nincs" }}
              </td>
            </tr>
            <tr>
              <th>Operátor</th>
              <td>
                <span v-if="task.operator_simple"
                  >{{ task.operator_simple.name }}
                  <button
                    v-if="
                      this.user.role_id == 7 &&
                      task.operator_simple &&
                      task.operator_id != user.id
                    "
                    @click="takeFromOperator"
                    class="btn btn-lime btn-xs rounded-pill"
                    :disabled="loading"
                  >
                    <i class="fa fa-cog fa-spin" v-if="loading"></i> Átveszem
                  </button></span
                >
                <span v-else>
                  nincs operátorhoz rendelve
                  <!--<button v-if="this.user.role_id == 7 && task.operator_id != user.id && task.status >= 20"
                @click="takeFromOperator" class="btn btn-lime btn-xs rounded-pill" :disabled="loading"><i class="fa fa-cog fa-spin" v-if="loading"></i> Felveszem</button>-->
                </span>
              </td>
            </tr>
            <tr>
              <th>
                Utasítás
                <i
                  v-if="workflow"
                  title="Utasítás részletei"
                  class="fa-solid fa-info-circle text-info cursor-pointer fa-xl"
                  v-b-modal.workflow_details_modal
                ></i>
                <b-modal
                  size="lg"
                  id="workflow_details_modal"
                  hide-footer
                  v-if="workflow"
                >
                  <template slot="modal-header">
                    <h4 class="modal-title">Utasítás részletei</h4>
                    <a
                      class="btn-close"
                      @click="$bvModal.hide('workflow_details_modal')"
                    ></a>
                  </template>
                  <b-container>
                    <p>{{ workflow.description }}</p>
                  </b-container>
                </b-modal>
              </th>
              <td>{{ workflow ? workflow.name : "nincs" }}</td>
            </tr>
            <tr v-if="task.started_at">
              <th>Elindítva</th>
              <td>
                <span class="badge bg-warning">{{ task.started_at }}</span>
              </td>
            </tr>
            <tr>
              <th>Engedélyeken szereplő kiegészítő információk</th>
              <td>{{ task.description ? task.description : "nincs" }}</td>
            </tr>
            <tr>
              <th class="align-middle">
                <span>
                  Státusz
                  <i
                    class="fa-solid fa-info-circle text-warning cursor-pointer fa-xl"
                    v-b-modal.next_status_terms
                    @click="checkNextStatusTerms"
                  ></i>
                </span>
                <b-modal
                  size="lg"
                  id="next_status_terms"
                  hide-footer
                  @hidden="next_status_terms = null"
                >
                  <template slot="modal-header">
                    <h4 class="modal-title">
                      Következő státuszba léptetés feltételei
                    </h4>
                    <a
                      class="btn-close"
                      @click="$bvModal.hide('next_status_terms')"
                    ></a>
                  </template>
                  <b-container>
                    <Loading
                      title="feltételek betöltése"
                      v-if="!next_status_terms"
                    >
                    </Loading>
                    <div class="table-responsive" v-else>
                      <table class="table">
                        <tbody>
                          <tr
                            v-for="(term, id) in next_status_terms"
                            :key="id"
                            v-show="
                              term.term !=
                                'Összes engedély jóváhagyása (Területvezető)' ||
                              task_permit_types.length == 0 ||
                              task_permit_types.filter((tpt) =>
                                [1, 4].includes(tpt.permit_type)
                              ).length == 0
                            "
                            class="text-white"
                            :class="{
                              'bg-red-300': !term.value,
                              'bg-green-300': term.value,
                            }"
                          >
                            <td class="align-middle text-center">
                              <i
                                class="fa fa-2x"
                                :class="{
                                  'fa-times-circle': !term.value,
                                  'fa-check-circle': term.value,
                                }"
                              ></i>
                            </td>
                            <td class="align-middle fs-5 fw-bold">
                              {{ term.term }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-container>
                </b-modal>
              </th>
              <td>
                <Loading mini v-if="!task_statuses"></Loading>
                <span
                  v-else
                  class="badge bg-default text-inverse fs-6"
                  :class="{
                    'bg-indigo text-white': task.status == 50,
                    'bg-green text-white': task.status == 70,
                  }"
                  ><i
                    v-if="[50, 70].includes(task.status)"
                    class="fa"
                    :class="{
                      'fa-forward': task.status == 50,
                      'fa-check-circle': task.status == 70,
                    }"
                  ></i>
                  {{
                    task_statuses.find((ts) => ts.id == task.status).name
                  }}</span
                >
              </td>
            </tr>
            <tr>
              <th class="border border-bottom-0 border-end-0">
                Megjegyzések
                <span v-if="task_comments">({{ task_comments.length }})</span
                ><br />
              </th>
              <td class="border border-bottom-0 border-end-0 border-start-0">
                <button class="btn btn-primary btn-xs" v-b-modal.comment-modal>
                  <i class="fa-solid fa-comment-medical"></i> Új Megjegyzés
                </button>
                <b-modal id="comment-modal" size="xl">
                  <template slot="modal-header">
                    <h4 class="modal-title">Megjegyzések</h4>
                    <a
                      class="btn-close"
                      @click="$bvModal.hide('comment-modal')"
                    ></a>
                  </template>
                  <b-container class="overflow-auto h-350px">
                    <div
                      class="row border py-2"
                      v-for="(comment, id) in task_comments"
                      :key="id"
                    >
                      <div class="col-1 align-self-center">
                        <span
                          class="fa-stack"
                          :title="
                            roles.find((r) => r.id == comment.role_id).name
                          "
                        >
                          <i class="fa fa-circle fa-stack-2x"></i>
                          <i
                            :class="
                              roles.find((r) => r.id == comment.role_id)
                                .icon_class
                            "
                            class="fa-stack-1x fa-inverse"
                          ></i>
                        </span>
                      </div>
                      <div class="col-4 ps-3">
                        <div>
                          <b>{{ comment.user_name }}</b>
                        </div>
                        <i class="fs-10px"
                          >{{ comment.created_at }}
                          <i class="fa-regular fa-clock"></i
                        ></i>
                      </div>
                      <div class="col-7">
                        <span>{{ comment.text }}</span>
                      </div>
                    </div>
                  </b-container>
                  <template #modal-footer>
                    <div class="w-100">
                      <form @submit.prevent="SendExtraComment()">
                        <div class="input-group">
                          <input
                            type="text"
                            class="form-control rounded-pill"
                            placeholder="Adj hozzá megjegyzést"
                            required
                            v-model="extra_comment"
                          />
                          <button type="submit" class="btn btn-link">
                            <i class="fa fa-paper-plane fa-lg"></i>
                          </button>
                        </div>
                      </form>
                    </div>
                  </template>
                </b-modal>
              </td>
            </tr>
            <tr class="border border-top-0 border-end-0">
              <td colspan="2">
                <div v-if="roles && task_comments">
                  <div
                    class="row border border-end-0 py-2"
                    v-for="(comment, id) in task_comments"
                    :key="id"
                    v-show="id < 5"
                  >
                    <div class="col-1 align-self-center">
                      <span
                        class="fa-stack"
                        :title="roles.find((r) => r.id == comment.role_id).name"
                      >
                        <i class="fa fa-circle fa-stack-2x text-dark"></i>
                        <i
                          :class="
                            roles.find((r) => r.id == comment.role_id)
                              .icon_class
                          "
                          class="fa-stack-1x fa-inverse"
                        ></i>
                      </span>
                    </div>
                    <div class="col-4 ps-3">
                      <div>
                        <b>{{ comment.user_name }}</b>
                      </div>
                      <i class="fs-10px"
                        >{{ comment.created_at }}
                        <i class="fa-regular fa-clock"></i
                      ></i>
                    </div>
                    <div class="col-7">
                      <p class="text-truncate" style="max-width: 185px">
                        {{ comment.text }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="row text-center mt-2"
                    v-if="task_comments.length > 0"
                  >
                    <div class="col">
                      <button
                        class="btn btn-indigo btn-xs ms-1"
                        v-b-modal.comment-modal
                      >
                        <i class="fa-solid fa-ellipsis"></i> Bővebben
                      </button>
                    </div>
                  </div>
                </div>
                <div v-else class="text-center">
                  <loading mini></loading>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <button
        v-if="
          this.user.role_id == 7 &&
          !task.operator_simple &&
          task.status == 20 &&
          (isolations.length != 0 ||
            task_boxes.length != 0 ||
            task_positions.length != 0)
        "
        @click="setMyselfAsOperator"
        class="btn btn-lime float-end"
        :disabled="loading"
      >
        <i class="fa-solid fa-user-astronaut" v-if="!loading"></i
        ><i v-else class="fa fa-spin fa-cog"></i> Felveszem
      </button>
      <div
        v-if="
          this.user.role_id == 5 &&
          [task.owner_id].includes(user.id) &&
          task.status == 10
        "
      >
        <button
          v-if="task.location_leader_id == task.owner_id"
          class="btn btn-success float-end"
          v-b-modal.one-person-accept-modal
          :disabled="loading"
        >
          <i class="fa fa-cog fa-spin" v-if="loading"></i>
          <i class="fa fa-check-circle" v-else></i>
          Tudomásul vétel
        </button>
        <button
          v-else
          @click="readyForEvaluation"
          class="btn btn-success float-end"
          :disabled="loading"
        >
          <i class="fa fa-envelope" v-if="!loading"></i>
          <i class="fa-solid fa-cog fa-spin" v-else></i>
          elküldöm tudomásul vételre a területvezetőnek
        </button>
      </div>
      <button
        @click="undoEvaluationSend"
        class="btn btn-danger float-end"
        v-if="
          this.user.role_id == 5 &&
          [task.owner_id].includes(user.id) &&
          task.status == 15
        "
        :disabled="loading"
      >
        <i class="fa-solid fa-clock-rotate-left" v-if="!loading"></i>
        <i class="fa-solid fa-cog fa-spin" v-else></i>
        Kiküldés visszavonása
      </button>
      <button
        v-if="
          task.status == 15 &&
          user.role_id == 3 &&
          [task.location_leader_id].includes(user.id)
        "
        class="btn btn-success float-end"
        v-b-modal.location-lead-accept-modal
        :disabled="is_task_positions_dirty || loading"
      >
        <i class="fa fa-check" v-if="!loading"></i
        ><i v-else class="fa fa-spin fa-cog"></i> Tudomásulvétel
      </button>
      <button
        v-if="
          task.status <= 15 && user.role_id == 5 && task.owner_id == user.id
        "
        class="btn btn-danger float-start"
        @click="deleteTask(task.id)"
        :disabled="loading"
      >
        <i class="fa fa-trash" v-if="!loading"></i
        ><i v-else class="fa fa-spin fa-cog"></i>
      </button>
      <button
        v-if="
          task.status == 15 &&
          user.role_id == 3 &&
          [task.location_leader_id].includes(user.id)
        "
        class="btn btn-danger"
        :disabled="is_task_positions_dirty || loading"
        v-b-modal.location-lead-decline
      >
        <i class="fa fa-arrow-rotate-left"></i> Visszaküldöm
      </button>
      <button
        v-if="
          task.status == 17 && user.role_id == 5 && user.id == task.owner_id
        "
        class="btn btn-success float-end"
        @click="projectLeadAccept()"
        :disabled="loading"
      >
        <i class="fa fa-check" v-if="!loading"></i
        ><i v-else class="fa fa-spin fa-cog"></i> Átveszem
      </button>
      <button
        v-b-modal.fn_probe_modal
        v-if="
          this.user.role_id == 5 &&
          task.owner_id == user.id &&
          task.status == 50
        "
        class="btn btn-red float-end"
      >
        Funkciópróba és/vagy lezárás
      </button>
      <FnProbeModal
        v-if="
          this.user.role_id == 5 &&
          task.owner_id == user.id &&
          task.status == 50
        "
        :task="task"
        :location_leads="location_leads"
        :location_leader_id="location_leader_id"
        @sendClosable="sendClosable"
      ></FnProbeModal>
      <b-modal
        id="location-lead-accept-modal"
        @ok="locationLeadAccept()"
        ok-title="Tudomásul veszem"
        cancel-title="Mégsem"
      >
        <template slot="modal-header">
          <h4 class="modal-title">Tudomásulvétel</h4>
          <a
            class="btn-close"
            @click="$bvModal.hide('location-lead-accept-modal')"
          ></a>
        </template>
        <b-container>
          <h1 class="text-center">
            <i
              class="fa-solid fa-circle-exclamation text-warning fa-3x fa-beat-fade"
              style="--fa-animation-duration: 3s"
            ></i>
          </h1>
          <h3 class="text-center">
            A fent megnevezett munkafolyamatot tudomásul veszem.
          </h3>
          <h5 class="text-center">
            Az adott helyszínen történő biztonságos munkavégzéshez szükséges
            speciális, lokális ismeretek, utasítások az elrendelővel ismertetve
            lettek.
          </h5>
          <h5 class="text-center">
            Az alábbi körülményeket kérem még figyelembe venni a munkavégzés
            során:
          </h5>
          <textarea
            class="form-control"
            v-model="task_comment_in_modal"
          ></textarea>
        </b-container>
      </b-modal>
      <b-modal
        id="one-person-accept-modal"
        @ok="onePersonAccept()"
        ok-title="Tudomásul vétel"
        cancel-title="Mégse"
      >
        <template slot="modal-header">
          <h4 class="modal-title">Feladat tudomásul vétele</h4>
          <a
            class="btn-close"
            @click="$bvModal.hide('one-person-accept-modal')"
          ></a>
        </template>
        <b-container>
          <h1 class="text-center">
            <i
              class="fa-solid fa-circle-exclamation text-warning fa-3x fa-beat-fade"
              style="--fa-animation-duration: 3s"
            ></i>
          </h1>
          <h3 class="text-center">A munkavégzést tudomásul veszem.</h3>
          <h4 class="text-center">
            A munkaterületen lévő kockázatokat megismertem, a munkaterületet
            munkavégzésre alkalmas állapotban átveszem.
          </h4>
          <h4 class="text-center">
            A munkavégzéssel kapcsolatos kockázatokat a munkafolyamat
            engedélyezése során kezelem(szükség esetén egyeztetek a
            területvezetővel).
          </h4>
          <h5 class="text-center">
            Az alábbi körülményeket kérem még figyelembe venni a munkavégzés
            során:
          </h5>
          <textarea
            class="form-control"
            v-model="task_comment_in_modal"
          ></textarea>
        </b-container>
      </b-modal>
      <b-modal
        size="sm"
        id="location-lead-decline"
        cancel-title="Mégse"
        ok-title="Visszaküldés"
        ok-variant="danger"
        cancel-variant="default"
        @ok="locationLeadDecline"
        :ok-disabled="loading"
      >
        <template slot="modal-header">
          <h4 class="modal-title">Feladat visszaküldése</h4>
          <a
            class="btn-close"
            @click="$bvModal.hide('location-lead-decline')"
          ></a>
        </template>
        <b-container>
          <loading title="visszaküldés" v-if="loading"></loading>
          <template v-else>
            <label class="form-label">Ajánlott területvezető:</label>
            <v-select
              v-if="location_leads"
              v-model="decline_location_leader_id"
              :options="location_leads"
              label="name"
              :reduce="(p) => p.id"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  v-bind="attributes"
                  v-on="events"
                  :placeholder="
                    decline_location_leader_id == null ? 'Válassz' : ''
                  "
                />
              </template>
            </v-select>
            <loading v-else mini></loading>
            <div
              v-if="errors.decline_location_leader_id"
              class="invalid-feedback d-block"
            >
              {{ errors.decline_location_leader_id[0] }}
            </div>
          </template>
        </b-container>
      </b-modal>
    </div>
  </panel>
</template>

<script>
import Loading from "@/components/Loading";
import Task from "@/apis/Task";
import Confirmation from "@/apis/Confirmation";
import moment from "moment";
import Validity from "@/apis/Validity";
import User from "@/apis/User";
import FnProbeModal from "@/pages/task/partials/FnProbeModal";

export default {
  components: {
    Loading,
    FnProbeModal,
  },
  props: [
    "task",
    "security_types",
    "location_leads",
    "ddc_user",
    "ddc_users",
    "partner_users",
    "black_lock_user",
    "workflow",
    "task_statuses",
    "task_positions",
    "task_boxes",
    "task_comments",
    "roles",
    "isolations",
    "task_permit_types",
    "is_task_positions_dirty",
  ],
  data() {
    return {
      loading: false,
      location_leader_id: this.task.location_leader_id,
      operator_id: this.task.operator_id,
      ddc_user_id: this.task.ddc_user_id,
      black_lock_user_id: this.task.black_lock_user_id,
      ddc_user_local: this.ddc_user,
      black_lock_user_local: this.black_lock_user,
      validity_records: false,
      end_date: null,
      end_time: null,
      with_time: false,
      next_status_terms: null,
      extra_comment: null,
      task_comment_in_modal: "",
      errors: [],
      decline_location_leader_id: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    task(val) {
      this.location_leader_id = val.location_leader_id;
      this.ddc_user_id = val.ddc_user_id;
      this.black_lock_user_id = val.black_lock_user_id;
      this.operator_id = val.operator_id;
    },
  },
  methods: {
    takeFromOwner() {
      Confirmation.swalCustomConfirm(
        "Biztosan átveszed a feladatot?",
        "Átveszem",
        "Ha átveszed a feladatot az előző Projektvezető már nem szerkesztheti!"
      ).then((response) => {
        if (response.isConfirmed === true) {
          this.loading = true;
          Task.updateOwner(this.task.id, { owner_id: this.user.id })
            .then(() => {
              this.$emit("task_parameter_updated", { owner_id: this.user.id });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    takeFromLocationLeader() {
      Confirmation.swalCustomConfirm(
        "Biztosan átveszed a feladatot?",
        "Átveszem",
        "Ha átveszed a feladatot az előző Területvezető már nem szerkesztheti!"
      ).then((response) => {
        if (response.isConfirmed === true) {
          this.loading = true;
          Task.updateLocationLeader(this.task.id, {
            location_leader_id: this.user.id,
          })
            .then(() => {
              this.$emit("task_parameter_updated", {
                location_leader_id: this.user.id,
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    diffLessThanThreeDays(datetime) {
      return moment.duration(moment(datetime).diff(moment())).asHours() <= 72;
    },
    getSlicedDate(datetime) {
      let m = moment(datetime);
      if (
        (m.hour() == 0 && m.minute() == 0) ||
        (m.hour() == 23 && m.minute() == 59)
      ) {
        return m.format("yyyy-MM-DD");
      } else {
        return m.format("yyyy-MM-DD HH:mm");
      }
    },
    getTaskValidityRecords() {
      this.validity_records = false;
      Task.getTaskValidityRecords(this.task.id).then((response) => {
        this.validity_records = response.data;
      });
    },
    extendTask() {
      let end_date_time = this.end_date
        ? moment(
            this.end_date +
              (this.end_time && this.with_time ? " " + this.end_time : " 23:59")
          )
            .tz("Europe/Budapest")
            .format()
        : this.end_date;
      Task.extendTask(this.task.id, { end_date_time: end_date_time }).then(
        () => {
          this.$bvModal.hide("extend_task_modal");
        }
      );
    },
    validityActiveUpdate(validity_id, active_val) {
      Validity.validityActiveUpdate(validity_id, { active: active_val }).then(
        (response) => {
          this.validity_records = response.data;
        }
      );
    },
    setDdcUser() {
      Task.setDdcUser(this.task.id, { ddc_user_id: this.ddc_user_id }).then(
        (response) => {
          if (response.data.ddc_user_id) {
            User.show(response.data.ddc_user_id).then((response) => {
              this.ddc_user_local = response.data;
              this.$emit("ddc_user_updated", response.data);
            });
          }
          this.$emit("update_task_positions");
        }
      );
    },
    setLocationLeader() {
      Task.setLocationLeader(this.task.id, {
        location_leader_id: this.location_leader_id,
      });
    },
    setBlackLockUser() {
      Task.setBlackLockUser(this.task.id, {
        black_lock_user_id: this.black_lock_user_id,
      }).then((response) => {
        if (response.data.black_lock_user_id) {
          User.show(response.data.black_lock_user_id).then((response) => {
            this.black_lock_user_local = response.data;
            this.$emit("black_lock_user_updated", response.data);
          });
        }
        this.$emit("update_task_positions");
      });
    },
    takeFromOperator() {
      Confirmation.swalCustomConfirm(
        "Biztosan átveszed a feladatot?",
        "Átveszem",
        "Ha átveszed a feladatot az előző operátor már nem szerkesztheti!"
      ).then((response) => {
        if (response.isConfirmed === true) {
          this.loading = true;
          Task.updateOperator(this.task.id, { operator_id: this.user.id })
            .then(() => {
              this.operator_id = this.user.id;
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    checkNextStatusTerms() {
      Task.checkNextStatusTerms(this.task.id).then((response) => {
        this.next_status_terms = response.data;
        this.$forceUpdate(this.next_status_terms);
      });
    },
    SendExtraComment() {
      Task.appendComment(this.task.id, { comment: this.extra_comment }).then(
        () => {
          this.extra_comment = null;
        }
      );
    },
    readyForEvaluation() {
      this.loading = true;
      Task.readyForEvaluation(this.task.id).finally(() => {
        this.loading = false;
        this.$emit("update_task_position_dirty", false);
      });
    },
    locationLeadDecline(vbModalEvt) {
      this.loading = true;
      vbModalEvt.preventDefault();
      if (!this.decline_location_leader_id) {
        this.$set(this.errors, "decline_location_leader_id", [
          "Ajánlott területvezető választása kötelező!",
        ]);
        this.loading = false;
      } else {
        Task.locationLeadDecline(this.task.id, {
          location_leader_id: this.decline_location_leader_id,
        }).then(() => {
          this.errors = [];
          this.$bvModal.hide("location-lead-decline");
          this.loading = false;
        });
      }
    },
    undoEvaluationSend() {
      this.loading = true;
      Task.undoEvaluationSend(this.task.id).finally(() => {
        this.loading = false;
        this.$emit("update_task_position_dirty", false);
      });
    },
    locationLeadAccept() {
      this.loading = true;
      Task.locationLeadAccept(this.task.id)
        .then(() => {
          if (this.task_comment_in_modal.length > 0) {
            Task.appendComment(this.task.id, {
              comment: this.task_comment_in_modal,
            }).finally(() => {
              this.loading = false;
              this.task_comment_in_modal = "";
            });
          } else {
            this.loading = false;
            this.task_comment_in_modal = "";
          }
        })
        .catch(() => {
          top.location.reload();
        });
    },
    projectLeadAccept() {
      Confirmation.swalCustomConfirm(
        "Átvétel",
        "Átveszem",
        "A munkavégzéssel, területtel kapcsolatos kockázatokat megismertem és kezeltem. A felmerülő kérdéseket a területvezetővel egyeztettem."
      ).then((response) => {
        if (response.isConfirmed === true) {
          this.loading = true;
          Task.projectLeadAccept(this.task.id).finally(() => {
            this.loading = false;
          });
          this.errors = [];
        }
      });
    },
    setMyselfAsOperator() {
      this.$swal({
        title: "Biztos felveszed a feladatot?",
        text: "ha felveszed a feladatot más operátorok nem szerkeszthetik!",
        type: "warning",
        icon: "question",
        iconColor: "orange",
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: "Felveszem",
        cancelButtonText: "Mégsem",
        confirmButtonClass: "btn btn-lg me-15px btn-warning",
        cancelButtonClass: "btn btn-lg btn-default",
      }).then((response) => {
        if (response.isConfirmed === true) {
          this.loading = true;
          Task.setOperator(this.task.id, { operator_id: this.user.id }).finally(
            () => {
              this.loading = false;
            }
          );
        }
      });
    },
    setClosable() {
      Confirmation.swalCustomConfirm(
        "A mai napon a munkaterületet visszaadom",
        "Lezárás",
        "A gép, gépsor, berendezés karbantartását, javítását, nagyjavítását végrehajtottuk és az érintett berendezés(ek) funkció próbáját elvégeztük. Az a biztonságos és rendeltetésszerű üzemeltetésre alkalmas."
      ).then((response) => {
        if (response.isConfirmed === true) {
          if (
            this.task_permit_types.filter((tp) => tp.status < 90).length > 0
          ) {
            Confirmation.swalCustomConfirm(
              "Biztos lezárhatóra állítod?",
              "Biztos lezárom",
              "A munkafolyamat tartalmaz olyan engedélyeket amelyek még nem lettek visszahozva!"
            ).then((second_response) => {
              if (second_response.isConfirmed === true) {
                this.sendClosable();
              }
            });
          } else {
            this.sendClosable();
          }
        }
      });
    },
    sendClosable(fn_probe_data = null, notifyFinished = null) {
      return Task.setClosable(this.task.id, fn_probe_data).finally(() => {
        this.$bvModal.hide("fn_probe_modal");
        if (notifyFinished) {
          notifyFinished();
        }
      });
    },
    onePersonAccept() {
      this.loading = true;
      Task.onePersonAccept(this.task.id).finally(() => {
        if (this.task_comment_in_modal.length > 0) {
          Task.appendComment(this.task.id, {
            comment: this.task_comment_in_modal,
          }).finally(() => {
            this.loading = false;
            this.task_comment_in_modal = "";
          });
        } else {
          this.loading = false;
          this.task_comment_in_modal = "";
        }
      });
    },
    chunkIntoN(arr, n) {
      const size = Math.ceil(arr.length / n);
      return Array.from({ length: n }, (v, i) =>
        arr.slice(i * size, i * size + size)
      );
    },
    deleteTask(id) {
      Confirmation.swalDelete().then((response) => {
        if (response.isConfirmed === true) {
          Task.delete(id)
            .then(() => {
              this.$router.push("/tasks");
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
  },
};
</script>
<style>
.modal-footer {
  display: block !important;
}
.form-check-input[disabled] {
  background: rgba(255, 0, 0, 0.2);
}
</style>
